import { YardPropertiesService } from '../../../../yard-properties.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AppClientConfigurationService, SupplementaryEquipment, TranslationService } from '@sdbn/common';
import { OuthandedSupplementaryEquipment, SupplementaryEquipmentSelection, SupplementaryEquipmentSelectionItem } from '../../register-entrance-leave.model';
import { TMCClientParameters } from '@sdbn/tmc-common';

@Component({
  selector: 'app-supplementary-equipment',
  templateUrl: './supplementary-equipment.component.html',
  styleUrls: ['./supplementary-equipment.component.scss']
})
export class SupplementaryEquipmentComponent implements OnInit {

  clientParameters = TMCClientParameters;

  @Input() equipments: Array<SupplementaryEquipment>;

  @Input() outhandedEquipments: Array<OuthandedSupplementaryEquipment>;

  @Input() direction: string;

  @Output() changed = new EventEmitter<SupplementaryEquipmentSelection>();

  @Output() validityChanged = new EventEmitter<boolean>();

  items = new Array<SupplementaryEquipmentSelectionItem>();

  noHandout: boolean;

  formGroup = new FormGroup({
    noHandout: new FormControl(false, [])
  });

  constructor(
    public cps: AppClientConfigurationService,
    public translationService: TranslationService,
    public yardPropertiesService: YardPropertiesService
  ) { }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      this.noHandout = value.noHandout;
      this.updateValidity();
      this.notifyChange();
    });

    this.updateValidity();
    this.notifyChange();
  }

  public handleSupplementaryEquipmentChange(item: SupplementaryEquipmentSelectionItem) {



    let items = this.items.filter(i => i.key !== item.key);
    if (item.checked) {
      items.push(item);
    }
    this.items = items;

    this.updateValidity();
    this.notifyChange();
  }

  private notifyChange() {
    this.changed.next(new SupplementaryEquipmentSelection({ noHandout: this.noHandout, items: this.items }));
  }

  private updateValidity() {

    console.log('updating validity of supplementary equipments', this.equipments, this.outhandedEquipments);

    let valid = true;

    if (this.direction === 'entrance') {

      let atLeastOneHandout = false;
      let allHandoutsValid = true;

      if (this.items != null) {
        for (let item of this.items) {
          if (item.checked) {
            atLeastOneHandout = true;
            if (item.parameter1 == null || item.parameter1 === '') {
              allHandoutsValid = false;
            }
          }
        }
      }

      if (!allHandoutsValid) {
        valid = false;
      }

      if (this.yardPropertiesService.isShowNoHandoutEnabled()) {
        if (!this.noHandout && !atLeastOneHandout) {
          valid = false;
        }
      }

    } else {

      for (let equipment of this.outhandedEquipments) {
        if (!equipment.selected) {
          valid = false;
        }
      }

    }

    this.validityChanged.next(valid);
  }

  public handleOuthandedChanged() {
    this.updateValidity();
  }

}
